import React from "react";
import { Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";

const ResultsSummaryTable = ({ results }) => {
    return (
        <>
            <Card variant="outlined" style={{ marginBottom: "2%", width: "50%" }}>
                <CardContent>
                    <Typography variant="h5" style={{ textAlign: "left", color: "red" }}>
                        Number of Discrepancies : {results.length}
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Document Name</TableCell>
                                    <TableCell>Discrepancy</TableCell>
                                    <TableCell>Value Found</TableCell>
                                    <TableCell>Correct Value</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {results.length > 0 &&
                                    results.map((p, i) => (
                                        <TableRow key={i}>
                                            <TableCell>{p.category}</TableCell>
                                            <TableCell>{p.name}</TableCell>
                                            <TableCell>{p.foundValue === "" || !p.foundValue ? "---" : p.foundValue}</TableCell>
                                            <TableCell>{p.trueValue === "" || !p.trueValue ? "---" : p.trueValue}</TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default ResultsSummaryTable;
